export const config = {
  title: "Rodrigo Bueno Realty Of America | Berwyn, IL Real Estate Services",
  meta: {
    description:
      "Rodrigo Bueno Realty Of America offers expert real estate services in Berwyn, IL. Helping you buy, sell, and invest in your dream property with confidence.",
    keywords: [
      "Berwyn IL real estate",
      "Rodrigo Bueno Realty Of America",
      "home buying Berwyn",
      "property selling Illinois",
      "realtor Berwyn IL"
    ],
    author: "Rodrigo Bueno Realty Of America",
    canonicalUrl: "https://www.buenoestateshomes.com/",
  },
  sections: {
    header: {
      businessName: "Rodrigo Bueno Realty Of America",
    },
    sectionB: {
      heroTitle: "Rodrigo Bueno Realty Of America",
      heroSubtitle: "Your Trusted Real Estate Partner in Berwyn, IL",
      learnAboutText: "Explore Listings",
      phoneNumber: "2244369323",
      phoneLabel: "(224) 436-9323",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2158963873/photo/aerial-view-of-finance-district-in-london.jpg?s=612x612&w=0&k=20&c=nJi-iIIbMROdHkaO8isPR84Y0WPrq0q8ZQ-ck1lGAxQ=",
      cardData: [
        {
          title: "Home Buying",
          description: "Let us help you find and secure your dream home in Berwyn, IL.",
        },
        {
          title: "Home Selling",
          description: "List your property with us and reach the right buyers fast.",
        },
        {
          title: "Property Investment",
          description: "Explore real estate investment opportunities with expert guidance.",
        },
      ],
      description:
        "Rodrigo Bueno Realty Of America is your go-to local expert in real estate services, helping clients buy and sell homes in Berwyn, IL with professionalism and integrity.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Whether you're buying, selling, or investing, we provide tailored services to ensure your success in the real estate market.",
      cards: [
        {
          title: "Buyer Representation",
          description: "Navigate the market confidently with our personalized home buying support.",
          imageSrc: "https://media.istockphoto.com/id/2197308465/photo/dynamic-business-meeting-with-engaged-professionals.jpg?s=612x612&w=0&k=20&c=4eawll0uEB1W0rk09Z4m6dlW3g0W2XenyJax01uIf8g=",
          imageAlt: "Home Buying",
        },
        {
          title: "Seller Services",
          description: "Get your property listed and sold with our strategic marketing approach.",
          imageSrc: "https://media.istockphoto.com/id/1404808614/photo/business-colleagues-came-to-an-agreement-with-car-salesperson-in-a-showroom.jpg?s=612x612&w=0&k=20&c=SfbZNvWFk-RhBlfPfcREAdCc5WrvsWKQafVFRU9dQBc=",
          imageAlt: "Selling Homes",
        },
        {
          title: "Market Analysis",
          description: "We provide accurate and up-to-date property valuations.",
          imageSrc: "https://media.istockphoto.com/id/1404294064/photo/three-business-people-meeting-and-looking-at-a-laptop-and-a-document.jpg?s=612x612&w=0&k=20&c=43CBb0LT46DrQ41hOFKQzky4pK7JpiElRC6KLek8gVk=",
          imageAlt: "Market Analysis",
        },
      ],
      otherServicesTitle: "Why Choose Us",
      otherServicesList: [
        "Local Market Knowledge",
        "Trusted Realtor in Berwyn, IL",
        "Personalized Service",
        "Strong Negotiation Skills",
        "Client-Focused Approach",
      ],
    },
    sectionD: {
      aboutTitle: "About Rodrigo Bueno Realty Of America",
      aboutImage: {
        src: "https://images.marketleader.com/MarketingImages/76/2405676_normal.jpg",
        alt: "Rodrigo Bueno Realty of America Logo",
      },
      aboutText: [
        "Rodrigo Bueno Realty Of America brings years of experience in the real estate industry, offering personalized service and expert market insights.",
        "We are committed to helping clients buy, sell, and invest in properties throughout Berwyn and the greater Illinois region.",
      ],
    },
    sectionE: {
      profileImage: "https://images.marketleader.com/Logos/92/921792_normal.png",
      profileAlt: "Rodrigo Bueno Realty Logo",
      businessName: "Rodrigo Bueno Realty Of America",
      contact: {
        phone: "2244369323",
        phoneLabel: "(224) 436-9323",
        email: "roa.buenoestates@gmail.com",
        website: "https://www.buenoestateshomes.com/",
        address: "Cermak Rd, Berwyn, IL 60402, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Cermak Rd, Berwyn, IL 60402, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2967.0628130143914!2d-87.78874538455217!3d41.850028979221436!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880e3393f9053e33%3A0x490fa73f9e0e6201!2sCermak%20Rd%2C%20Berwyn%2C%20IL%2060402%2C%20USA!5e0!3m2!1sen!2sus!4v1692589973620!5m2!1sen!2sus",
    },
  },
};

export default config;
